import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { useLocation } from "react-router-dom";
import { getItemMenu, getItemsTeasaureByParent, domain } from "../../assets/js/api";
import { getCurrentLanguage } from "../../assets/js/functions";

export default function Actividades({ section_id }) {
    const location = useLocation();
    const [categories, setCategories] = useState(null);
    const [item, setItem] = useState(location.state?.item || null);
    const [categoryItems, setCategoryItems] = useState({});

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);


    useEffect(() => {
        if (item) {
            getItemsTeasaureByParent(item, null, true).then((data) => setCategories(data));
        }
    }, [item]);

    useEffect(() => {
        if (categories && item && categories.length > 0) {
            categories.forEach((categoria) => {

                getItemsTeasaureByParent(item, categoria, true).then((data) => {
                    setCategoryItems(prevItems => ({
                        ...prevItems,
                        [categoria.section_id]: data
                    }));
                });
            });
        }
    }, [categories]);


    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header></Header>

                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--l">
                        <h1 className="has-text-centered">{item ? item.term : ""}</h1>
                        <p className="has-text-centered">{item ? item.abstract : ""}</p>
                    </div>
                    <div className="wrapper mt-8">
                        <div className="columns is-variable is-8">
                            {categories && categories.length > 0 ? (
                                categories.map((categoria) => (
                                    <div className="column flow--l" key={"categoria_" + categoria.section_id}>
                                        <h2 className="has-text-primary is-size-3">{categoria.term}</h2>
                                        <ul className="download-list has-text-weight-medium">
                                            {categoryItems[categoria.section_id] && categoryItems[categoria.section_id].length > 0 ? (
                                                categoryItems[categoria.section_id].map((item, index) => {
                                                  let pdfUrl = '';
                                                  if(item.pdf_resolved){
                                                    const pdfArray = JSON.parse(item.pdf_resolved);
                                                    if (pdfArray.length === 1) {
                                                      pdfUrl = pdfArray[0]
                                                    } else {
                                                      pdfUrl = getCurrentLanguage() === 'es' ? pdfArray[0] : pdfArray[1];
                                                    }
                                                  }
                                                  return (
                                                    <li key={`${categoria.section_id}_${item.id || index}`}>

                                                        {item.pdf_resolved && (
                                                            <a
                                                                href={domain + pdfUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <span>{item.term}</span>
                                                            </a>
                                                        )}
                                                    </li>
                                                )})
                                            ) : (
                                                <li key={`no_items_${categoria.section_id}`}>No items found</li>
                                            )}
                                        </ul>
                                    </div>
                                ))
                            ) : ''}
                        </div>
                    </div>
                </main>
                <Footer></Footer>
            </div>
        </Layout>
    );
}